import ApartmentGallery from '../frontend/apartment_gallery';
import ApartmentInfo from '../frontend/apartment_info';
import ApartmentCarousel from '../frontend/apartment_carousel';
import ApartmentCarouselThumbnails from '../frontend/apartment_carousel_thumbnails';
import FaqMediaGallery from '../frontend/faq_media_gallery';
import IvsVideoPlayer from '../frontend/ivs_video_player';
import MarkdownRenderer from '../common/markdown_renderer';

const Frontend = {
  ApartmentCarousel,
  ApartmentGallery,
  ApartmentInfo,
  ApartmentCarouselThumbnails,
  FaqMediaGallery,
  IvsVideoPlayer,
  MarkdownRenderer,
};

window.Frontend = Frontend;
